import { useMutation } from '@tanstack/react-query';

import type { PhoneNumberMutationSchema, PhoneNumberQuerySchema } from '@/_schemas/phone-numbers';
import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

export const useCreateMutation = () =>
  useMutation<{ data: PhoneNumberQuerySchema }, ApiError, PhoneNumberMutationSchema>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/phone-numbers/`,
        payload,
      }),
  });

export const useUpdateMutation = (id: string) =>
  useMutation<{ data: PhoneNumberQuerySchema }, ApiError, PhoneNumberMutationSchema>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/phone-numbers/${id}`,
        method: 'PUT',
        payload,
      }),
  });

export const useDeleteMutation = () =>
  useMutation<unknown, unknown, { id: string }>({
    mutationKey: ['PHONE_DELETE'],
    mutationFn: ({ id }) =>
      apiClient.request({
        endpoint: `/api/v1/phone-numbers/${id}`,
        method: 'DELETE',
      }),
  });
